<template>
    <div class="cafsmodalmask" tabindex="-1" role="dialog" v-if="show">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="modal-title" style="color:black"><h3 class="m-0">{{ $t('new-ellipsis') }}</h3></div>
                    <button type="button" class="close" data-dismiss="modal" :aria-label="$t('close')"
                        @click="$emit('close')">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="row mb-2">
                        <div class="col-md-6 d-flex flex-column">
                            <router-link v-for="item in menu.filter((el, i) => i % 2 === 0)" :key="item.id" :to="item.to"
                                class="btn btn-primary btn-lg mb-2">
                                {{ item.caption }}
                            </router-link>
                        </div>
                        <div class="col-md-6 d-flex flex-column">
                            <router-link v-for="item in menu.filter((el, i) => i % 2 !== 0)" :key="item.id" :to="item.to"
                                class="btn btn-primary btn-lg mb-2">
                                {{ item.caption }}
                            </router-link>
                        </div>
                    </div>
                    <div class="row" style="color:black" v-if="reqAction.length > 0">
                        <div class="col-12 text-center">
                            <div class="list-group text-left">
                                <div class="list-group-item">
                                    <h3 class="m-0">{{ $t('action-required') }}</h3>
                                </div>
                                <div class="list-group-item clearfix" v-for="item in reqAction" :key="item.id"
                                @click="$router.push(`/forms/view/${item.formresponse_id}`);">
                                    {{ item.formresponse_data.title }}
                                    <div v-if="item.user_id != $UserSession.getValue.call(this, 'id')" class="float-right">
                                        <small class="text-muted">{{ $t('submitter-colon') }} {{ item.user_displayname
                                        }}</small>
                                    </div>
                                    <span class="badge float-right" :class="deadlineClass(item)" v-if="showDeadline(item)">
                                        {{ $t('deadline-colon') }} {{ $datetime.getLocaleStringFromTimeStamp(item.formresponse_deadline, false) }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        show: {
            type: Boolean,
            required: true,
        },
    },
    mounted() {
        this.initMenu().then(() => {
            this.loading = false
        })
        this.fetchRequiringAction();
    },
    data() {
        return {
            loading: true,
            menu: [],
            reqAction: []
        }
    },
    methods: {
        initMenu() {
            if (!this.$UserSession.hasPriv('ALL') && this.$UserSession.hasPriv('ADD_REFLECTION') && this.$config.hasModule('timeline')) {
                this.menu.push({
                    caption: this.$t('reflection'),
                    to: '/reflections/save/0'
                });
            }
            if (this.$UserSession.hasPriv('FORM_ASSIGN')) {
                this.menu.push({
                    caption: this.$t('assign-form-task'),
                    to: '/forms/assign'
                });
            }
            if (this.$config.hasModule('clinical') && this.$UserSession.hasPriv('TREATMENTSESSION_EDIT')) {
                this.menu.push({
                    caption: this.$t('treatment-session'),
                    to: '/clinical/treatmentsession/'
                });
            }
            if (this.$UserSession.hasPriv('TESTS')) {
                this.menu.push({
                    caption: this.$t('test'),
                    to: '/tests/new/'
                });
            }
            return this.fetchMenu();
        },
        fetchMenu() {
            return this.$cfetch(`${this.$settings.APIBaseURL}/workflows/menu`, {
                method: 'GET',
            }).then(res => {
                if (res.status !== 'SUCCESS') throw new Error('Unexpected error fetching workflow menu')
                res.menu.forEach(item => {
                    this.menu.push({
                        caption: item.caption,
                        to: `/workflows/${item.id}/stages/${item.stage_id}`
                    })
                });
            }).catch(err => {
                this.$log.error.call(this, err)
            })
        },
        fetchRequiringAction() {
            this.$cfetch(`${this.$settings.APIBaseURL}/forms/response/listrequiringattention`, {
                data: {
                    limit: 4
                }
            })
                .then((res) => {
                    if (res.status == "SUCCESS") {
                        this.reqAction = res.formresponses;
                    }
                })
                .catch((error) => {
                    this.$log.error.call(this, error);
                });
        },
        deadlineClass(item) {
            var now = Date.now() / 1000;
            if (item.formresponse_deadline < now) {
                return 'badge-danger';
            }
            if (item.formresponse_deadline < now + (3600 * 24 * 3)) {
                return 'badge-warning';
            }
            return 'badge-info';
        }
    },
    computed: {
        showDeadline() {
            return (item) => {
                if (item.formresponse_deadline) {
                    if (item.formresponse_completed == 0) {
                        return true;
                    }
                }
                return false;
            }

        }
    }
}
</script>
